import * as React from 'react';
import { SelectSingle } from 'app/area/shared/translated-components';
import { OptionsType } from 'ui/common/select/types';
import { ComplexValue } from 'app/types-shared';
import { BowtieTranslation } from '../../constants';

interface TooltipConnectedHeaderProps {
  connections: ComplexValue<number>[];
  selected: ComplexValue<number>;
  selectConnection: (selected: ComplexValue<number>) => void;
  applicationUrl: string;
  translation: BowtieTranslation;
}

export const TooltipConnectedHeader: React.FC<TooltipConnectedHeaderProps> = ({
  connections, selected, selectConnection, applicationUrl, translation
}) => {

  if (!connections || connections.length === 0) {
    return null;
  }

  if (connections.length === 1) {
    return <p className="tooltip-header"><b>{connections[0].description}:</b></p>;
  }

  const onLoadOptions = () => ({});
  const options: ComplexValue<number>[] = connections.map(c => ({
    value: c.value,
    description: c.description,
    icon: applicationUrl + c.icon
  }));

  return <>
    <p className="tooltip-header">
      <b>{translation.connected_cases}:</b>
    </p>
    <SelectSingle
      componentId={'select-connection-type'}
      className={'tooltip-header'}
      valueItem={selected}
      options={options}
      optionsDisplaySetting={{ type: OptionsType.flat }}
      showIcons={true}
      onChange={selectConnection}
      onLoadOptions={onLoadOptions}
    />
  </>;
};
